import styled from "styled-components";

/* ====== 響應式背景浮水印舞台（維持不變即可） ====== */
export const WatermarkStage = styled.div`
  --wm-scale: clamp(0.36, calc(100vw / 1024), 1);
  position: absolute;
  top: 0;
  width: 1024px; /* Figma 基準寬度 */
  height: 900px; /* 夠包住所有絕對元素 */
  transform: translateX(-50%) scale(var(--wm-scale));
  transform-origin: top center;
  pointer-events: none;
  z-index: 8;
  opacity: 0.6;
`;

/* 基底樣式：加上 justify-content，讓 WMScam 能置中 */
const WMBase = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center; /* ✅ 置中 */
  white-space: nowrap;
  font-family: "PingFang TC", "SF Pro TC", "Noto Sans TC", system-ui, sans-serif;
  font-style: normal;
`;

export const WMLoan = styled(WMBase)`
  width: 276px;
  height: 72px;
  left: -8px;
  top: 600px;
  font-weight: 300;
  font-size: 16px;
  line-height: 26px;
  color: rgba(255, 255, 255, 0.35);
`;

export const WMParking = styled(WMBase)`
  width: 353px;
  height: 72px;
  left: 355px;
  top: 636px;
  font-weight: 300;
  font-size: 16px;
  line-height: 26px;
  color: rgba(255, 255, 255, 0.67);
`;

export const WMProfit = styled(WMBase)`
  width: 374px;
  height: 72px;
  left: 311px;
  top: 393px;
  font-weight: 300;
  font-size: 22px;
  line-height: 26px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const WMAbnormal = styled(WMBase)`
  width: 756px;
  height: 72px;
  left: 277px;
  top: 474px;
  font-weight: 500;
  font-size: 32px;
  line-height: 26px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const WMAtm = styled(WMBase)`
  width: 332px;
  height: 72px;
  left: -104px;
  top: 429px;
  font-weight: 300;
  font-size: 14px;
  line-height: 26px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;
